/* eslint-disable import/prefer-default-export */
import {
  makeStyles,
  withStyles,
  useTheme,
  styled,
} from '../ExternalLibraries';

module.exports = {
  makeStyles,
  withStyles,
  useTheme,
  styled,
};
